
import { Component, Mixins } from "vue-property-decorator";
import { IQuoteBehavior } from "../../../../../../documaker/domain/format/objects";
import { IQuoteBehaviorPropertyEditable, instanceOfIQuoteBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class QuoteBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IQuoteBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IQuoteBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isQuoteBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIQuoteBehaviorPropertyEditable(s) && s.quoteBehavior().isEditable(), false);
  }

  get quoteBehavior(): IQuoteBehavior {
    return this.readPropertyOrDefault(s => s.quoteBehavior().getValue(), { isEnable: false });
  }

  set quoteBehavior(value: IQuoteBehavior) {
    this.writePropertyWhenValid(s => s.quoteBehavior().setValue(value));
  }
}
